module.exports = __webpack_public_path__ + "static/assets/f8f1e0cb52a292321bb82ac6b1fa9e1e.png";